import React from 'react';
import ContentMasteryTestFailureAttemptRateSummary from './ContentMasteryTestFailureAttemptRateSummary';
import { ContentMasteryFailureAttemptRateListService } from '../../services/ContentListService';
import { observer } from 'mobx-react';

const ContentMasteryTestFailureAttemptRateSummaryContainer = () => {
  const summary = ContentMasteryFailureAttemptRateListService.getChart();
  return (
    <ContentMasteryTestFailureAttemptRateSummary
      isLoading={
        ContentMasteryFailureAttemptRateListService.fetchCurrent.fetching ||
        ContentMasteryFailureAttemptRateListService.fetchPrevious.fetching
      }
      previousValue={summary.previous}
      currentValue={summary.current}
      formatter={ContentMasteryFailureAttemptRateListService.getFormattedValue}
    />
  );
};

export default observer(ContentMasteryTestFailureAttemptRateSummaryContainer);
